import { Model } from "pinia-orm";

export default class DocumentType extends Model {
  static name = "DocumentType";
  static entity = "documentTypes";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      name: this.attr(),
    };
  }
}
